import { useQuery } from '@tanstack/react-query';
import { getActorPerformance, getByCommune, type DateRange } from '@/api/dashboards';

export function useActorPerformance(range: DateRange) {
  return useQuery({
    queryKey: ['dashboards', 'actor-performance', range],
    queryFn: () => getActorPerformance(range),
    staleTime: 60_000,
  });
}

export function useByCommune(range: DateRange) {
  return useQuery({
    queryKey: ['dashboards', 'by-commune', range],
    queryFn: () => getByCommune(range),
    staleTime: 60_000,
  });
}
